export const handleCalcIsOff = ( state ) => {
    alert( 'Turn the calculator on first!' );
    return state;
};
